import { css, keyframes } from '@emotion/react';

const Animation = keyframes`
  to {
    opacity: 0;
    transform: translateY(160px);
  }
`;
export const bottomLeave = css`
  animation: ${Animation} 0.4s ease forwards;
  will-change: opacity, transform;
`;
